/* src/app/views/doctor/doctor-detail/doctor-detail.component.css */
.border-blue-600 {
  border: 1px solid #0000ac;
}
.visit-type {
  position: relative;
  right: 22px;
  top: 83px;
}
input.visit-type:checked + label {
  color: #0f9a8c;
  background-color: #EEF3F1;
}
input.visit-type:hover + label,
.bg-primary:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}
input.date-select.hidden {
  display: none;
}
.card {
  border: 2px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.3s ease;
}
input.date-select + label.card {
  color: #475569;
}
input.date-select:checked + label.card {
  border-color: #0f9a8c;
  background-color: #EEF3F1;
  color: #0f9a8c;
  transform: scale(1.05);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  transform: scale(1.02);
}
input.hour-select:checked + label {
  border-color: #0f9a8c;
  background-color: #0f9a8c;
  color: white;
  transform: scale(1.05);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.carousel-section {
}
.carousel-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
  overflow: hidden;
  position: relative;
}
.carousel-header {
  direction: ltr;
}
.carousel-controls {
  display: flex;
  justify-content: space-between;
}
.carousel-btn {
  padding: 10px;
  margin: -15px;
  z-index: 10;
  font-size: 1.5rem;
  top: -75px;
  position: relative;
}
.carousel-wrapper {
  display: flex;
  transition: transform 0.5s ease;
  width: 100%;
  transform: translateX(0);
}
.carousel-slide {
  display: flex;
  min-width: 20%;
  justify-content: space-around;
}
.card {
  flex: 1;
  padding: 28px 0px;
  border: 1px solid #cbcbcb;
  margin: 0 10px;
  border-radius: 4px;
}
.card img {
  width: 100%;
  height: auto;
}
@media (max-width:762px) {
  .carousel-slide {
    min-width: 50% !important;
  }
}
input:disabled + label {
  color: gray;
  cursor: not-allowed;
  opacity: 0.6;
  box-shadow: 0 0 0;
}
/*# sourceMappingURL=doctor-detail.component.css.map */
